import { useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientFirstHeadSnapshotQuery } from 'api/generated/graphql';
import { useError, parseLegalClientFirstHeadSnapshotEntity } from 'api/helpers';

import { RequestOptions } from '../types';

export const useLegalClientFirstHeadSnapshot = (
  firstHeadId: string,
  versionId: string,
  options: RequestOptions = {}
) => {
  const {
    data,
    loading,
    error: apolloError,
    refetch,
  } = useLegalClientFirstHeadSnapshotQuery({
    variables: { id: firstHeadId, versionId },
    ...options,
  });

  const error = useError(apolloError, false);

  const snapshot = useMemo(
    () =>
      data?.legalClientFirstHeadSnapshot
        ? parseLegalClientFirstHeadSnapshotEntity(
            data.legalClientFirstHeadSnapshot
          )
        : null,
    [data?.legalClientFirstHeadSnapshot]
  );

  return {
    snapshot,
    loading,
    error,
    isError: !!apolloError,
    refetch,
  };
};
